import { Experiment } from 'api/experiment/types'
import { graphql } from 'msw'
import db from '../db'

const experimentHandlers = [
  graphql.query('listExperiments', (req, res, ctx) => {
    let experiments = db.experiment.getAll(
      (experiment) => experiment.placement.id === req.variables.placementId
    )

    if (!experiments.length) experiments = null
    return res(ctx.data({ experiments }))
  }),

  graphql.mutation('createExperiment', (req, res, ctx) => {
    const { placementId } = req.variables

    const experiment = db.experiment.create({
      ...(req.variables as Experiment),
      placement: {
        id: placementId,
      },
    })

    return res(ctx.data({ experimentCreate: { experiment } }))
  }),

  graphql.mutation('updateExperiment', (req, res, ctx) => {
    const experimentData = req.variables as Experiment

    const newVariants = experimentData.placementVariants.map((variant) => {
      variant.mobileBannerUrl =
        'https://ofw-assets-stg.s3.eu-west-1.amazonaws.com/opd/placement_mobile_banner/eb558be0-6c51-4f79-a0f7-08b8f32546a5.png'
      return variant
    })
    const experiment = db.experiment.update({
      ...experimentData,
      placementVariants: newVariants,
    })
    return res(ctx.data({ experimentUpdate: { experiment } }))
  }),

  graphql.mutation('disableExperiment', (req, res, ctx) => {
    const { placementVariantId, id } = req.variables

    const data = db.experiment.get(id)

    const winnerVariant = data.placementVariants.find(
      (variant) => variant.id === placementVariantId
    )
    const experimentId = data.id
    const placementId = data.placement.id
    const updatePlacement = db.placement.update({
      id: placementId,
      ...winnerVariant,
    })
    db.experiment.remove(experimentId)

    return res(
      ctx.data({
        experimentSetWinningVariant: { data, placementId, updatePlacement },
      })
    )
  }),
]

export default experimentHandlers
